import { render, staticRenderFns } from "./Excess.vue?vue&type=template&id=52ee8263&scoped=true&"
import script from "./Excess.vue?vue&type=script&lang=js&"
export * from "./Excess.vue?vue&type=script&lang=js&"
import style0 from "./Excess.vue?vue&type=style&index=0&id=52ee8263&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee8263",
  null
  
)

export default component.exports